import script from "./videoBand.vue?vue&type=script&lang=js"
export * from "./videoBand.vue?vue&type=script&lang=js"

import "./videoBand.vue?vue&type=style&index=0&id=55a442fa&lang=scss"

const __exports__ = script;

export default __exports__